<div class=" mt-4">
  <section>
    <div class="scrollmenu">
      <a [routerLink]="['/pos/businessinfo']"> Business-info </a>
      <a [routerLink]="['/pos/customer/new']"> Customer </a>
      <a [routerLink]="['/pos/Employee/new']"> Employee </a>
      <a [routerLink]="['/pos/orders/new']"> Orders</a>
      <a [routerLink]="['/pos/taxfee/new']"> Tax Fee </a>
      <a [routerLink]="['/pos/category/new']"> Item-Category </a>
      <a routerLinkActive = "active" class="active menu" [routerLink]="['/pos/item/new']"> Items </a>
      <a [routerLink]="['/pos/businesshour/new']"> Business-Hours </a>
      <!-- <a [routerLink]="['/pos/order/new']"> Order </a>
      <a [routerLink]="['/pos/orderreceipt/new']"> Order Receipt </a>
      <a [routerLink]="['/pos/payment/new']"> Payment </a>
      <a [routerLink]="['/pos/paymentrecipt/new']"> Payment Receipt </a>
      <a [routerLink]="['/pos/tip/new']"> Tips </a> -->

      <!--  <a [routerLink]="['/pos/orderregister']"> Order Register </a>  -->
      <!--  <a [routerLink]="['/pos/ordertype/new']"> Order Type </a> -->
      <!--   <a [routerLink]="['/pos/tender/new']">  Tender </a>  -->
    </div>

  </section>
  <section class="mt-2">
    <div class="">
      <div class="row">
        <div class="col-md-11">
          <div class="text-right py-2">
            <button class="btn dash-btns" [routerLink]="['/pos/item/manage']">Manage Item Details</button>

          </div>
        </div>
        <div class="col-md-10 offset-md-1">
          <div class="card-1">
            <div class="row">
              <div class="col-md-12">
                <div class="text-center mb-5">
                  <img src="assets/img/new/pos.svg" />
                </div>
                <div class="text-center">
                  <div class="col-md-12" *ngIf="isNewitem">
                    <h4 class="font20 gary-t">Lets create a New item here.</h4>
                  </div>
                  <div class="col-md-12" *ngIf="isUpdateitem">
                    <h4 class="font20 gary-t">Lets update an item here.</h4>
                  </div>

                </div>

                <div class="py-3">
                  <form #fnewprepaidcard="ngForm">
                    <div class="row mx-0">
                      <div class="col-md-12" *ngIf="isNewitem">

                        <form #form="ngForm" class="addpaynow">
                          <div class="form-group formgroup-tm">
                            <div class="row pt-2">

                              <div class="col-md-6">
                                
                                <div class="form-group formgroup-tm ">
                                  <label class="customlabel">Item Image </label>
                                  <!-- <input  class="formcontrol-user form-control" type="file"  id="itemimage" [formControl]="itemimage" (change)="getFileDetails($event.target.files)">  
                                                             -->
                                  <div class="formcontrol-user">
                                    <input type="file"
                                    matTooltip="Upload file with(.jpeg/.jpg/.png/.bmp/.doc/.docx/.pdf) extensions"
                                    id="itemimage" multiple (change)="getFileDetails($event,9)" style="padding: 11px;">
                                  </div>
                                 
                                </div>

                              </div>
                              <div class="col-md-6">
                                
                                <div class="form-group formgroup-tm">
                                  <label class="customlabel">Name *</label>
                                  <input class="formcontrol-user form-control" type="text" placeholder="Name" id="Name"
                                    name="Name" [formControl]="Name" required>

                                </div>
                                <span class="text-danger"
                                  *ngIf="Name.invalid && (Name.dirty || Name.touched)">{{firstNameError()}}</span>

                              </div>
                            </div>
                            <div class="row pt-2">

                            
                              <div class="col-md-6">
                               
                                <div class="form-group formgroup-tm">
                                  <label class="customlabel">Alternative Name</label>
                                  <input class="formcontrol-user form-control" type="text"
                                    placeholder="Alternative Name  " id="AlternativeName" name="AlternativeName"
                                    [formControl]="AlternativeName">
                                  <!-- <mat-error *ngIf="AlternativeName.invalid">{{AlternativeNameError()}}</mat-error>  -->

                                </div>
                                <span class="text-danger"
                                  *ngIf="AlternativeName.invalid && (AlternativeName.dirty || AlternativeName.touched)">{{AlternativeNameError()}}</span>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group formgroup-tm">
                                  <label class="customlabel">Description *</label>
                                  <input class="formcontrol-user form-control" type="text" placeholder="Description  "
                                    id="Description" name="Description" [formControl]="Description" required>

                                </div>
                                <span class="text-danger"
                                  *ngIf="Description.invalid && (Description.dirty || Description.touched)">{{DescriptionError()}}</span>
                              </div>
                            </div>


                            <div class="row pt-2">

                            
                              <div class="col-md-6">
                               
                                <div class="form-group formgroup-tm">
                                  <label class="customlabel">Price *</label>
                                  <input class="formcontrol-user form-control" type="text" placeholder="Price"
                                    id="Price" name="Price" [formControl]="Price">


                                </div>
                                <span class="text-danger"
                                  *ngIf="Price.invalid && (Price.dirty || Price.touched)">{{priceerror()}}
                                </span>
                              </div>
                              <div class="col-md-6">
                                
                                <div class="form-group formgroup-tm">

                                  <label class="customlabel">Price Type *</label>
                                  <div class="selectcustom mb-0">
                                    <ngx-select [items]="Type" id="PriceType" placeholder="Price Type" name="Price Type"
                                    [formControl]="PriceType" required>
                                  </ngx-select>
                                  </div>
                                
                                 
                                </div>
                                <span class="text-danger" *ngIf="PriceType.invalid && (PriceType.dirty || PriceType.touched)">{{typeerrors()}}</span>
                              </div>
                            </div>

                            <div class="row pt-2">
                              <div class="col-md-6">
                                  
                                <div class="form-group formgroup-tm">
  
                                  <label class="customlabel">Discount Type *</label>
                                  <div class="selectcustom mb-0">
                                    <ngx-select [items]="Type1" id="DiscountType" placeholder="Discount Type" name="Discount Type"
                                    [formControl]="DiscountType" required>
                                  </ngx-select>
                                  </div>
                                
                                 
                                </div>
                                <span class="text-danger" *ngIf="DiscountType.invalid && (DiscountType.dirty || DiscountType.touched)">{{typeerrors()}}</span>
                              </div>
  
                              <div class="col-md-6">
                                 
                                <div class="form-group formgroup-tm">
                                  <label class="customlabel">DiscountValue *</label>
                                  <input class="formcontrol-user form-control" type="text" placeholder="DiscountValue"
                                    id="DiscountValue" name="DiscountValue" [formControl]="DiscountValue">
  
  
                                </div>
                                <span class="text-danger"
                                  *ngIf="DiscountValue.invalid && (DiscountValue.dirty || DiscountValue.touched)">{{DiscountValueerror()}}
                                </span>
                              </div>
                            
                          
                            </div>

                            <!-- <div class="row pt-2">
                
                                                    <div class="col-md-5 col-lg-4">
                                                      <label class="customlabel">Item Options  *</label>
                                                  </div>
                                                   
                                                    <div class="col-md-6">
                                                      <div class="form-group formgroup-tm">
                                                        <input  class="formcontrol-user form-control" type="text" placeholder="Item Options  " id="ItemOptions" name="ItemOptions" [formControl]="ItemOptions">
                                                      </div>
                                                      <span class="text-danger" *ngIf="ItemOptions.invalid && (ItemOptions.dirty || ItemOptions.touched)">{{itemoptionerror()}}</span>
                                                  </div>
                                              </div> -->
                            <div class="row pt-2">
                                <div class="col-md-6">
                                <div class="form-group formgroup-tm">
                                  <label class="customlabel">Category Name *</label>
                                  <select [formControl]="categorynames" class="formcontrol-user form-control"
                                    placeholder="Category Name" (change)="taxtypeSelection()">
                                    <option value="" disabled selected hidden>Please Select Category Name...</option>
                                    <option *ngFor="let item of isMyList" [ngValue]="item.Id">
                                      {{item.CategoryName}}
                                    </option>
                                  </select>
                                </div>
                                </div>
                              <div class="col-md-6">
                                <div class="form-group formgroup-tm">
                                  <label class="customlabel">Taxes *</label>
                                  <input class="formcontrol-user form-control" type="text" placeholder="Taxes  "
                                    id="Taxes" name="Taxes" maxlength="10" [(ngModel)]="TaxFeeRate"
                                    [formControl]="Taxes" required readonly>
                                </div>
                                <span class="text-danger" *ngIf="Taxes.invalid && (Taxes.dirty || Taxes.touched)">{{taxeerror()}}</span> 
                              </div>
                            </div>


                            <div class="row pt-2">

                         
                              <div class="col-md-6">
                                
                                <div class="form-group formgroup-tm">
                                  <label class="customlabel">Product Code*</label>
                                  <input class="formcontrol-user form-control" type="text" placeholder="Product Code*  "
                                    id="ProductCode" name="ProductCode" maxlength="6" [formControl]="ProductCode" (change)="checkproduct()"
                                    required>

                                </div>
                                <span style="color:red;" *ngIf="duplicateproductcode">Product Code already exist</span>
                                <span class="text-danger"
                                  *ngIf="ProductCode.invalid && (ProductCode.dirty || ProductCode.touched)">{{productCodeerror()}}</span>
                              </div>
                              <div class="col-md-6">
                                
                                <div class="form-group formgroup-tm">
                                  <label class="customlabel">BarCode *</label>
                                  <input class="formcontrol-user form-control" type="text" placeholder="BarCode"
                                    id="BarCode" name="BarCode" [formControl]="BarCode" required>

                                </div>
                                <!-- <span class="text-danger"
                                  *ngIf="BarCode.invalid && (BarCode.dirty || BarCode.touched)">{{BarCodeError()}}</span> -->

                              </div>
                            </div>
                       <div class="row pt-2">


                             <div class="col-md-6">
                                
                              <div class="form-group formgroup-tm">
                                <label class="customlabel">GTIN *</label>
                                <input class="formcontrol-user form-control" type="text" placeholder="GTIN"
                                  id="GTIN" name="GTIN" [formControl]="GTIN" required>

                              </div>
                              <!-- <span class="text-danger"
                                *ngIf="GTIN.invalid && (GTIN.dirty || GTIN.touched)">{{GTINError()}}</span> -->

                            </div>
                            <div class="col-md-6">
                               
                              <div class="form-group formgroup-tm">
                                 <label class="customlabel">Sku </label>
                                <input class="formcontrol-user form-control" type="text" placeholder="Sku  " id="Sku"
                                  name="Sku" maxlength="10" [formControl]="Sku" required>

                              </div>
                            </div>
                            <div class="col-md-6">
                               
                              <div class="form-group formgroup-tm">
                                <label class="customlabel">HSN Code </label>
                                <input class="formcontrol-user form-control" type="text" placeholder="HSNCode" id="HSNCode"
                                  name="HSNCode"  [formControl]="HSNCode">

                              </div>
                              

                            </div>
                      </div>
                       
                            </div>
                           
                           
                            <div class="text-right pt-3">
                              <button class="btn dash-btns" type="button" id="saveitems" color="primary"
                                [disabled]="Name.invalid||ProductCode.invalid||AlternativeName.invalid||Price.invalid||duplicateproductcode||Taxes.invalid||Description.invalid||GTIN.invalid||BarCode.invalid"
                                (click)="newitem()">Submit</button>
                            </div>

                          
                        </form>
                      </div>
                     
                      <div class="col-md-12"  *ngIf="isUpdateitem">

                        <form #form="ngForm" class="addpaynow">
                          <div class="form-group formgroup-tm">
                            <div class="row pt-2">

                              

                              <div class="col-md-6">
                                <label class="customlabel">Item Image </label>
                                <div class="form-group formgroup-tm"  *ngIf="Imageavalabel">
                                
                                  <img [ngStyle]="{'width': maxWidth+'px', 'height': maxHeight+'px'}"
                                    src="data:image/jpeg;base64,{{content}}" fxFlexAlign="center" id="merchatImage"
                                    class="fade-in-on-icon-sidenav img-thumbnail img-rounded">

                                  <input type="file"
                                    matTooltip="Upload file with(.jpeg/.jpg/.png/.bmp/.doc/.docx/.pdf) extensions"
                                    id="itemimage" multiple (change)="getFileDetails($event,9)">

                                </div>

                                <div class="form-group formgroup-tm" *ngIf="noImageavalabel">
                                
                                  <img [ngStyle]="{'width': maxWidth+'px', 'height': maxHeight+'px'}"
                                  src="assets/img/no-preview.png" fxFlexAlign="center" id="merchatImage"
                                    class="fade-in-on-icon-sidenav img-thumbnail img-rounded">

                                  <input type="file"
                                    matTooltip="Upload file with(.jpeg/.jpg/.png/.bmp/.doc/.docx/.pdf) extensions"
                                    id="itemimage" multiple (change)="getFileDetails($event,9)">

                                </div>
                                <div class="form-group formgroup-tm"  *ngIf="Imageavalabel1">
                                
                                  <img [ngStyle]="{'width': maxWidth+'px', 'height': maxHeight+'px'}"
                                    [src]=imageurl fxFlexAlign="center" id="merchatImage"
                                    class="fade-in-on-icon-sidenav img-thumbnail img-rounded">

                                  <input type="file"
                                    matTooltip="Upload file with(.jpeg/.jpg/.png/.bmp/.doc/.docx/.pdf) extensions"
                                    id="itemimage" multiple (change)="getFileDetails($event,9)">

                                </div>

                                <div class="form-group formgroup-tm" *ngIf="noImageavalabel1">
                                
                                  <img [ngStyle]="{'width': maxWidth+'px', 'height': maxHeight+'px'}"
                                  [src]=imageurl  fxFlexAlign="center" id="merchatImage"
                                    class="fade-in-on-icon-sidenav img-thumbnail img-rounded">

                                  <input type="file"
                                    matTooltip="Upload file with(.jpeg/.jpg/.png/.bmp/.doc/.docx/.pdf) extensions"
                                    id="itemimage" multiple (change)="getFileDetails($event,9)">

                                </div>



                              </div>
                            </div>
                            <div class="row pt-2">

                              <div class="col-md-6">
                                
                                <div class="form-group formgroup-tm">
                                  <label class="customlabel">Name *</label>
                                  <input class="formcontrol-user form-control" type="text" placeholder="Name" id="Name"
                                    name="Name" [formControl]="Name" [(ngModel)]="rows.Name" (keydown)="onKey()"
                                    required>

                                </div>
                                <span class="text-danger"
                                  *ngIf="Name.invalid && (Name.dirty || Name.touched)">{{firstNameError()}}</span>

                              </div>
                              <div class="col-md-6">
                               
                                <div class="form-group formgroup-tm">
                                  <label class="customlabel">Alternative Name </label>
                                  <input class="formcontrol-user form-control" type="text"
                                    placeholder="Alternative Name  " id="AlternativeName" name="AlternativeName"
                                    (keydown)="onKey()" [formControl]="AlternativeName"
                                    [(ngModel)]="rows.AlternativeName">
                                  <!-- <mat-error *ngIf="AlternativeName.invalid">{{AlternativeNameError()}}</mat-error>  -->

                                </div>
                                <span class="text-danger"
                                  *ngIf="AlternativeName.invalid && (AlternativeName.dirty || AlternativeName.touched)">{{AlternativeNameError()}}</span>
                              </div>
                            </div>


                            <div class="row pt-2">

                              <div class="col-md-6">
                               
                                <div class="form-group formgroup-tm">
                                  <label class="customlabel">Description *</label>
                                  <input class="formcontrol-user form-control" type="text" placeholder="Description  "
                                    id="Description" name="Description" [(ngModel)]="rows.Description"
                                    (keydown)="onKey()" [formControl]="Description" required>

                                </div>
                                <span class="text-danger"
                                  *ngIf="Description.invalid && (Description.dirty || Description.touched)">{{DescriptionError()}}</span>
                              </div>
                             
                                <!-- <input type="hidden" class="formcontrol-user form-control" [(ngModel)]="rid" id="id" name="id" [formControl]="id">
                                 <input type="hidden" class="formcontrol-user form-control" [(ngModel)]="rdatetime" id="date" name="date" [formControl]="date"> -->

                                <div class="col-md-6">
                                  
                                  <div class="form-group formgroup-tm">
                                    <label class="customlabel">Price *</label>
                                    <input class="formcontrol-user form-control" type="text" placeholder="Price"   id="Price" name="Price" [(ngModel)]="rows.ActualAmount" (keydown)="onKey()"
                                      [formControl]="Price">


                                  </div>
                                  <span class="text-danger"
                                    *ngIf="Price.invalid && (Price.dirty || Price.touched)">{{priceerror()}}
                                  </span>
                                </div>
                       

                              <!-- <div class="row pt-2">
                
                                                    <div class="col-md-5 col-lg-4">
                                                      <label class="customlabel">Item Options  *</label>
                                                  </div>
                                                   
                                                    <div class="col-md-6">
                                                      <div class="form-group formgroup-tm">
                                                        <input  class="formcontrol-user form-control" type="text" placeholder="Item Options  " id="ItemOptions" name="ItemOptions" [(ngModel)]="rows.ItemOptions" [formControl]="ItemOptions">
                                                      </div>
                                                      <span class="text-danger" *ngIf="ItemOptions.invalid && (ItemOptions.dirty || ItemOptions.touched)">{{itemoptionerror()}}</span>
                                                  </div>
                                              </div> -->

                            </div>


                          <div class="row pt-2">
                            <div class="col-md-6">
                                <div class="form-group formgroup-tm">
                                  <label class="customlabel">Price Type *</label>
                                  <div class="selectcustom mb-0">
                                    <ngx-select [items]="Type" id="PriceType" placeholder="Price Type" name="role"   [(ngModel)]="PriceTypedata" [formControl]="PriceType" (select)="onKey()" required>
                                    </ngx-select>
                                  </div>
                                </div>

                            </div>
                              <div class="col-md-6">
                                <label>Category Name</label>
                                <select [formControl]="categorynames" class="formcontrol-user form-control"
                                  placeholder="Category Name" [(ngModel)]="EditCategoryName" (change)="onKey()"
                                  (change)="edittaxtypeSelection()">
                                 <option [value]="EditCategoryName" disabled selected hidden>{{EditCategoryName}}</option> 
                                  <option *ngFor="let item of categorylist">
                                    {{item.CategoryName}}

                                  </option>

                                </select>
                                <!-- <option value="0">{{EditCategoryName}}</option> -->
                                <!-- value={{item.id}} -->
                                <!-- [(ngModel)]="EditCategoryName" -->
                              </div>
                            </div>

                            
                            <div class="row pt-2">
                              <div class="col-md-6">
                                  
                                <div class="form-group formgroup-tm">
  
                                  <label class="customlabel">Discount Type *</label>
                                  <div class="selectcustom mb-0">
                                    <ngx-select [items]="Type1" id="DiscountType" placeholder="Discount Type" name="Discount Type"
                                    [(ngModel)]="rows.DiscountType" (keydown)="onKey()" (change)="DisCountcal()" [formControl]="DiscountType" required>
                                  </ngx-select>
                                  </div>
                                
                                 
                                </div>
                                <span class="text-danger" *ngIf="DiscountType.invalid && (DiscountType.dirty || DiscountType.touched)">{{typeerrors()}}</span>
                              </div>
   
                              <div class="col-md-6">
                                 
                                <div class="form-group formgroup-tm">
                                  <label class="customlabel">DiscountValue *</label>
                                  <input class="formcontrol-user form-control" type="text" placeholder="DiscountValue"
                                  [(ngModel)]="rows.DiscountValue" (keydown)="onKey()"  (change)="DisCountcal()" id="DiscountValue" name="DiscountValue" [formControl]="DiscountValue">
  
  
                                </div>
                                <span class="text-danger"
                                  *ngIf="DiscountValue.invalid && (DiscountValue.dirty || DiscountValue.touched)">{{DiscountValueerror()}}
                                </span>
                              </div>
                            
                          
                            </div>




                            <div class="row pt-2">


                              <div class="col-md-6">
                                
                                <div class="form-group formgroup-tm">
                                  <label class="customlabel">Taxes *</label>
                                  <input class="formcontrol-user form-control" type="text" placeholder="Taxes  "
                                    (keydown)="onKey()" id="Taxes" name="Taxes" maxlength="10" [(ngModel)]="TaxFeeRate"
                                    [formControl]="Taxes" required readonly>

                                </div>
                                <span class="text-danger" *ngIf="Taxes.invalid && (Taxes.dirty || Taxes.touched)">{{taxeerror()}}</span>
                              </div>
                              <div class="col-md-6">
                               
                                <div class="form-group formgroup-tm">
                                  <label class="customlabel">Product Code*</label>
                                  <input class="formcontrol-user form-control" type="text" placeholder="Product Code * "
                                    id="ProductCode" name="ProductCode" maxlength="6" [(ngModel)]="rows.ProductCode"
                                    (keydown)="onKey()" [formControl]="ProductCode"   (change)="checkproduct()">

                                </div>
                                <span style="color:red;" *ngIf="duplicateproductcode">Product Code already exist</span>
                                <span class="text-danger"
                                  *ngIf="ProductCode.invalid && (ProductCode.dirty || ProductCode.touched)">{{productCodeerror()}}</span>
                              </div>
                            </div>

                            <div class="row pt-2">
                              <div class="col-md-6">
                                <div class="form-group formgroup-tm">
                                <label class="customlabel">BarCode *</label>
                                <input class="formcontrol-user form-control" type="text" placeholder="BarCode"
                                    id="BarCode" name="BarCode" [formControl]="BarCode" [(ngModel)]="rows.BarCode"
                                    (keydown)="onKey()">

                                </div>
                                <!-- <span class="text-danger"
                                  *ngIf="BarCode.invalid && (BarCode.dirty || BarCode.touched)">{{BarCodeError()}}</span> -->

                              </div>
                              <div class="col-md-6">
                                <div class="form-group formgroup-tm">
                                <label class="customlabel">GTIN *</label>
                                <input class="formcontrol-user form-control" type="text" placeholder="GTIN"
                                    id="GTIN" name="GTIN" [formControl]="GTIN" [(ngModel)]="rows.GTIN"
                                    (keydown)="onKey()">

                                </div>
                                <!-- <span class="text-danger"
                                  *ngIf="GTIN.invalid && (GTIN.dirty || GTIN.touched)">{{GTINError()}}</span> -->

                              </div>
                              <div class="col-md-6">
                                
                                <div class="form-group formgroup-tm">
                                  <label class="customlabel">Sku </label>
                                  <input class="formcontrol-user form-control" type="text" placeholder="Sku  " id="Sku"
                                    name="Sku" maxlength="10" [formControl]="Sku" [(ngModel)]="rows.Sku"
                                    (keydown)="onKey()" required>

                                </div>

                              </div>
                              <div class="col-md-6">
                                
                                <div class="form-group formgroup-tm">
                                  <label class="customlabel">HSN Code </label>
                                  <input class="formcontrol-user form-control" type="text" placeholder="HSNCode" id="HSNCode"
                                    name="HSNCode"  [formControl]="HSNCode" [(ngModel)]="rows.HSNCode"  (keydown)="onKey()">

                                </div>
                              </div>
                            </div>



                            <!-- <img style="height: 100px;width:300px" src="data:image/png;base64,{{img}}" fxFlexAlign="center" class="fade-in-on-icon-sidenav"> -->
                            <!-- <img [ngStyle]="{'width': maxWidth+'px', 'height': maxHeight+'px'}"src="data:image/jpeg;base64,{{img}}" fxFlexAlign="center"id="merchatImage" class="fade-in-on-icon-sidenav img-thumbnail img-rounded"> -->
                            <!-- <img [ngStyle]="{'width': maxWidth+'px', 'height': maxHeight+'px'}"src="data:image/jpeg;base64,{{img}}" fxFlexAlign="center"id="merchatImage" class="fade-in-on-icon-sidenav img-thumbnail img-rounded">
                                       -->


                            <div class="text-right pt-3">
                              <button class="btn dash-btns" type="button" id="saveitems" color="primary"
                                [disabled]="Name.invalid||ProductCode.invalid||AlternativeName.invalid||Price.invalid  ||Description.invalid ||!isReadytoUpdateitem||duplicateproductcode||Taxes.invalid||Description.invalid||GTIN.invalid||BarCode.invalid"
                                (click)="updateitem()">Update</button>
                              <!-- ||!isReadytoUpdateitem -->
                            </div>

                          </div>
                        </form>
                      </div>





                    </div>
                  </form>








                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

</div>